<template>
  <v-container
    fluid
    style="max-width: 1000px;"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <v-card
          flat
          outlined
        >
          <v-card-title class="my-2">
            <span class="font-weight-bold">
              タイムライン
            </span>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-timeline dense>
              <v-timeline-item
                v-for="(data, i) in tlData"
                :key="i"
                :color=colorByDataExist(data)
              >
                <span
                  v-if="data.showYear"
                  class="font-weight-bold text-h2"
                >
                  <v-divider class="my-4" />
                  {{ yearConvertedFormat(data.month) }}年
                </span>
                <v-card
                  class="elevation-2"
                  min-height="140"
                >
                  <v-toolbar
                    :color=colorByDataExist(data)
                    dark
                    flat
                    height="40"
                  >
                    <strong class="text-h3">{{ monthConvertedFormat(data.month) }}月</strong>
                  </v-toolbar>
                  <v-card-text
                    v-if="data.content.length"
                    class="py-2"
                  >
                    <div
                      v-for="(content, j) in data.content"
                      :key="j"
                      class="mb-2"
                    >
                      <div
                        v-if="dayConvertedFormat(content.date)"
                        class="text-caption grey--text"
                      >
                        {{ dayConvertedFormat(content.date) }}日
                      </div>
                      <strong>{{ content.name }}</strong>
                      <div class="text-caption">
                        {{ content.subname }}
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      studyData: [],
      shikakuData: [],
      tlData: [],
    }),
    computed: {
      currentYear () {
        return new Date().getFullYear()
      },
    },
    created () {
      this.arrangeStudyData()
      this.arrangeShikakuData()
      this.createTlData()
    },
    methods: {
      createTlData () {
        const now = new Date()
        // 2年後を終点とする
        const futureEnd = new Date(now.getFullYear(), now.getMonth() + 25)
        // 一番古い取得日を探す
        let oldestDate = new Date(now.getFullYear(), now.getMonth())
        const shikakuList = this.$store.state.user.shikakuList
        for (const item of shikakuList) {
          if (item.shutokubi) {
            const d = new Date(item.shutokubi)
            if (d < oldestDate) oldestDate = d
          }
        }
        // 起点月〜終点月のリストを生成して逆順にする
        const months = []
        let current = new Date(oldestDate.getFullYear(), oldestDate.getMonth())
        while (current <= futureEnd) {
          months.push(current.toISOString().substr(0, 7))
          current = new Date(current.getFullYear(), current.getMonth() + 1)
        }
        months.reverse()
        const allData = []
        for (const formattedDate of months) {
          var list = []
          for (let c = 0; c < this.studyData.length; c++) {
            if (this.studyData[c].date) {
              if (this.studyData[c].date.indexOf(formattedDate) !== -1) {
                list.push(this.studyData[c])
              }
            }
          }
          for (let d = 0; d < this.shikakuData.length; d++) {
            if (this.shikakuData[d].date) {
              if (this.shikakuData[d].date.indexOf(formattedDate) !== -1) {
                list.push(this.shikakuData[d])
              }
            }
          }
          if (list.length === 0) continue
          list.sort((a, b) => {
            if (!a.date) return 1
            if (!b.date) return -1
            return b.date.localeCompare(a.date)
          })
          allData.push({ month: formattedDate, content: list })
        }
        // 年が変わるタイミングで年ラベルを表示するフラグを付与
        for (let i = 0; i < allData.length; i++) {
          const currentYear = this.yearConvertedFormat(allData[i].month)
          const prevYear = i > 0 ? this.yearConvertedFormat(allData[i - 1].month) : null
          allData[i].showYear = currentYear !== prevYear
        }
        this.tlData = allData
      },
      arrangeStudyData () {
        const studyData = []
        var studyList = this.$store.state.user.studyList
        for (let i = 0; i < studyList.length; i++) {
          var name = studyList[i].name
          var date = studyList[i].shikenbi
          studyData.push({
            name: name,
            subname: '試験日',
            date: date,
          })
          name = studyList[i].name
          date = studyList[i].kekkahappyou
          studyData.push({
            name: name,
            subname: '結果発表',
            date: date,
          })
          this.studyData = studyData
        }
      },
      arrangeShikakuData () {
        const shikakuData = []
        var shikakuList = this.$store.state.user.shikakuList
        for (let i = 0; i < shikakuList.length; i++) {
          /* 取得日 */
          var name = shikakuList[i].name
          var date = shikakuList[i].shutokubi
          shikakuData.push({
            name: name,
            subname: '取得日',
            date: date,
          })
          /* 有効期限 */
          name = shikakuList[i].name
          date = shikakuList[i].yuukoukigen
          shikakuData.push({
            name: name,
            subname: '有効期限',
            date: date,
          })
          /* 更新期限 */
          name = shikakuList[i].name
          date = shikakuList[i].koushinkigen
          shikakuData.push({
            name: name,
            subname: '更新期限',
            date: date,
          })
        }
        this.shikakuData = shikakuData
      },
      monthConvertedFormat (yearAndMonth) {
        var dateObject = new Date(yearAndMonth)
        return dateObject.getMonth() + 1
      },
      yearConvertedFormat (yearAndMonth) {
        var dateObject = new Date(yearAndMonth)
        return dateObject.getFullYear()
      },
      dayConvertedFormat (date) {
        if (!date) return ''
        const parts = date.split('-')
        if (parts.length < 3) return ''
        return parseInt(parts[2], 10)
      },
      colorByDataExist (data) {
        if (data.content.length) {
          return 'red lighten-2'
        } else {
          return 'grey'
        }
      },
    },
  }
</script>

<style>
.nobr {
  display: inline-block;
}

/* Smart Phone */
@media screen and (max-width: 479px) {
  h2 {
     font-size: 36px;
  }
}
</style>
